import { render, staticRenderFns } from "./ObtainedLicenseIndex.vue?vue&type=template&id=6000e1f3&"
import script from "./ObtainedLicenseIndex.vue?vue&type=script&lang=js&"
export * from "./ObtainedLicenseIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports